import { css } from '@emotion/css';

export const linkButtonFocusStyles = css`
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--focus-secondary);
  }
`;

export const linkButtonInverseFocusStyles = css`
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-primary), 0 0 0 0.32rem var(--focus-secondary);
  }
`;
